import { Link } from "@tanstack/react-router";

import { useCurrentPlan } from "../api/queries/useCurrentPlan";
import { runDisplayName } from "../domain/format";
import { useLabels } from "./useLabels";

/**
 * "Current plan: run started 8 Sep 2026, 08:23 · Legacy scenario 1485", or "No plan yet".
 * Clicking it goes to the run.
 */
export function CurrentPlanLabel({ className }: { className?: string }) {
  const labels = useLabels();
  const { currentPlan, isPending } = useCurrentPlan();

  if (isPending) {
    return <span className={`h-3 w-48 animate-pulse rounded-sm bg-muted ${className ?? ""}`} />;
  }

  if (!currentPlan) {
    return (
      <span className={`type-caption text-muted-foreground ${className ?? ""}`}>No plan yet</span>
    );
  }

  return (
    <Link
      to="/runs/$runId"
      params={{ runId: currentPlan.id }}
      className={`type-caption rounded-sm bg-state-run-current-bg px-xs py-[2px] text-state-run-current-fg hover:underline ${className ?? ""}`}
    >
      {labels.currentPlan}: {runDisplayName(currentPlan)}
    </Link>
  );
}
